var _circle, _circle2, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoalsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.5,
    stroke: "#434243"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2,
    fill: "#434243"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.8435,
    y: 4.68506,
    width: 1,
    height: 10,
    transform: "rotate(45 18.8435 4.68506)",
    fill: "#434243"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2864 2.82797C19.3994 2.71502 19.5926 2.77353 19.6239 2.93017L19.8781 4.20074C19.8939 4.27992 19.9558 4.3418 20.035 4.35764L21.3055 4.61175C21.4622 4.64308 21.5207 4.83634 21.4077 4.94929L20.3335 6.02357C20.2862 6.07085 20.2184 6.09138 20.1528 6.07826L18.6207 5.77185C18.5416 5.75602 18.4797 5.69413 18.4639 5.61496L18.1574 4.08289C18.1443 4.01732 18.1648 3.94953 18.2121 3.90225L19.2864 2.82797Z",
    fill: "#434243"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalsIcon);
export default __webpack_public_path__ + "static/media/goals-icon.4544bfdc0e29a48b753bcf75a114192f.svg";
export { ForwardRef as ReactComponent };